/**
 * The funnel's theming decision. `dark` and `light` force an explicit Pluma
 * theme; `default` applies none and inherits the visitor's ambient
 * (OS-preference-driven) color scheme.
 */
export type SignupColorScheme = 'dark' | 'light' | 'default';

export function resolveSignupColorScheme(args: {
  isStartup: boolean;
  isSignupDarkModeEnabled: boolean;
}): SignupColorScheme {
  // The startup flow is always presented in light mode, dark-mode flag or not.
  if (args.isStartup) {
    return 'light';
  }
  return args.isSignupDarkModeEnabled ? 'dark' : 'default';
}
